import axios from 'axios'

export async function getOpenAlexWorkCount(searchTerm: string) {
  const encodedTitle = encodeURIComponent(searchTerm)
  const url = `https://api.openalex.org/works?search=${encodedTitle}`
  const response = await axios.get<{ meta: { count: number } }>(url)
  const count = response.data?.meta?.count ?? 0
  return count
}
